import React from 'react';
import DynamicComponentBaseProps from './DynamicComponentBaseProps';
import { DynamicComponetsRegistry } from './DynamicComponetsRegistry';

type Props = {
  baseComponentName: string;
  componentProps?: DynamicComponentBaseProps;
  defaultComponentRender?: () => JSX.Element;
}

const DynamicComponetWrapper = ({ baseComponentName, componentProps, defaultComponentRender }: Props) => {
  const renderDynamicComponent = () => {
    let componentName = `${baseComponentName}${process.env.REACT_APP_CLIENT}`;
    const dynamicComponent = DynamicComponetsRegistry[componentName];
    if (dynamicComponent !== undefined) {
      return dynamicComponent(componentProps);
    } else if (defaultComponentRender){
      return defaultComponentRender();
    } else {
      console.log(`Dynamic component ${componentName} isn't registered.`);
      return <></>;
    }
  }

  return renderDynamicComponent();
}

export default DynamicComponetWrapper;